import React from "react";
import {
  ClickAwayListener,
  createTheme,
  ThemeProvider,
  Tooltip,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

const themeForToolTip = createTheme({
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          background: "var(--primary-theme-color)",
          minWidth: "45rem",
          "&&& .MuiTooltip-arrow ": {
            fontSize: "3rem",
            color: "var(--senary-theme-color)",
          },
          "&&& .MuiTooltip-arrow:before ": {
            border: "1px solid var(--duodenary-grey-color)",
          },
          border: "1px solid var(--duodenary-grey-color)",
          display: "flex",
          borderRadius: "1.2rem",
          // position: 'absolute'
        },
      },
    },
  },
});

const NotificationTooltip = ({
  children,
  openNotification,
  title,
  onCloseNotification,
}: any) => {

  const navigate = useNavigate();

  const handleClose = () => {
    onCloseNotification(false);
    navigate("/");
  };

  const handleOnClick = () => {
    console.log("notification clickeddd");
  };

  return (
    <div style={{ position: 'absolute', right: '21rem', top: '5rem' }}>
      <ThemeProvider theme={themeForToolTip}>
        <ClickAwayListener onClickAway={handleClose}>
          <div>
            <Tooltip
              open={openNotification}
              arrow
              PopperProps={{
                disablePortal: true, // Keep the tooltip within the same DOM hierarchy
                modifiers: [
                  {
                    name: "offset",
                    options: {
                      offset: [0, 10], // Adjust the vertical offset if needed (e.g., 10px below the icon)
                    },
                  },
                ],
              }}
              onClose={handleClose}
              onClick={handleOnClick}
              disableFocusListener
              disableHoverListener
              disableTouchListener
              title={title}
              placement="top" // Set tooltip to appear above the icon aligned to the right
            >
              {children}
            </Tooltip>
          </div>
        </ClickAwayListener>
      </ThemeProvider>
    </div>
  );
};

export default NotificationTooltip;
